import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '../components/ui/button';
import { CreatePayerForm } from '../components/CreatePayerForm';

export const CreatePayerPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto p-6">
      <div className="flex items-center gap-4 mb-6">
        <Link to="/payers">
          <Button variant="outline" size="sm">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Payers
          </Button>
        </Link>
        <h1 className="text-3xl font-bold">Create Payer</h1>
      </div>

      <CreatePayerForm />
    </div>
  );
};
